import { render, staticRenderFns } from "./orderDetailDlg.vue?vue&type=template&id=78b84882"
import script from "./orderDetailDlg.vue?vue&type=script&lang=js"
export * from "./orderDetailDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports